import React from 'react';
import './OrderReview.css';

const OrderReview = () => {
    return (
        <div>
            <h1>This is order review page</h1>
        </div>
    );
};

export default OrderReview;